import React from 'react'

interface Props {
  onPrev: () => void
  onNext: () => void
}
export const Arrows: React.FC<Props> = ({ onPrev, onNext }) => (
  <>
    <div className="absolute top-0 left-0 h-100 flex justify-center flex-column pointer-events-none">
      <div className="pointer-events-auto pointer pa2" onClick={onPrev}>
        <ArrowLeft />
      </div>
    </div>
    <div className="absolute top-0 right-0 h-100 flex justify-center flex-column pointer-events-none">
      <div className="pointer-events-auto pointer pa2" onClick={onNext}>
        <ArrowRight />
      </div>
    </div>
  </>
)

const ArrowRight = () => (
  <svg width="14" height="26" viewBox="0 0 14 26" fill="none">
    <path d="M1 1L12 13L0.999996 25" stroke="#141E2D" strokeWidth="2" />
  </svg>
)
const ArrowLeft = () => (
  <svg width="14" height="26" viewBox="0 0 14 26" fill="none">
    <path d="M13 25L2 13L13 1" stroke="#141E2D" strokeWidth="2" />
  </svg>
)
